import styled from 'styled-components';

export const GridWrapper = styled('div')`
    height: 150px;
`;
